import React from "react";
import InternalNavbarButtons from "../components/patch/patch-navbar/internal-navbar-buttons";
import ExternalNavbarButtons from "src/components/patch/patch-navbar/external-navbar-buttons";
function PatchFooter() {
  return (
    <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-start gap-10 px-20 pb-10 pt-20">
      <div className="flex w-full items-center justify-between gap-3 max-[780px]:flex-col max-[780px]:items-start">
        <a
          href="https://procomps.gg/"
          className="relative float-left w-1/4 py-[5px] text-[#333] no-underline"
        >
          <img
            src="images/logo_ProComps.png"
            loading="lazy"
            width="148"
            alt=""
            className="mt-0 inline-block max-w-[170px]"
          />
        </a>
        <div className=" w-3/4 text-left font-poppins text-[16.8px] leading-[21px] text-[#d8d8d8] ">
          © All rights reserved by ProComps. ProComps isn't endorsed by Riot Games and doesn't
          reflect the views or opinions of Riot Games or anyone officially involved in producing or
          managing League of Legends. League of Legends™ and Riot Games are trademarks or
          registered trademarks of Riot Games, Inc.
        </div>
      </div>
      <div className="flex w-full items-center justify-between gap-4 max-[780px]:flex-col">
        <InternalNavbarButtons
          className="text-[#868686] hover:text-[#868686] max-[600px]:flex-col"
          variant="footer"
        />
        <ExternalNavbarButtons />
      </div>

      <div className=" flex w-full items-center justify-center gap-4 font-unbounded text-[11px] uppercase text-[#868686] max-[991px]:flex-col ">
        <a href="https://procomps.gg/legal/privacy-policy.html">Privacy Policy</a>
        <a href="https://procomps.gg/legal/terms-and-conditions.html">Terms and Conditions</a>
        <a href="https://procomps.gg/legal/privacy-policy.html#accordion-13">
          Notice to California Residents
        </a>
        <a href="https://procomps.gg/legal/cookie-policy.html" className="">
          Cookie Policy
        </a>
        <a href="https://procomps.gg/legal/disclaimer.html">Disclaimer</a>
      </div>
    </div>
  );
}

export default PatchFooter;
